<div class="r-form-group search-container">
    <div class="row" style="align-items:center">
        <p-button type="button" class="filter-btn" (click)="displaySidebar = true" icon="pi pi-filter"></p-button>
        <app-atn-export-excel [request]="request" [fileName]="'BusinessCoupon'"></app-atn-export-excel>
    </div>
</div>
<p-sidebar [(visible)]="displaySidebar" [baseZIndex]="10000">
    <div class="header">{{'LIDS.TITLE_SIDEBAR' |translate}}</div>
    <div class="filters">
         <div class="r-form-group">
      <label class="title">{{ 'LIDS.END_DATE' | translate }}</label>
      <p-calendar [(ngModel)]="expireAtRange" [selectionMode]="'range'" dateFormat="dd/mm/yy" [showButtonBar]="true"
        [clearButtonStyleClass]="'clear-button'" (onSelect)="filterCreatedDate()" (onClearClick)="filterCreatedDate()">
      </p-calendar>
    </div>
            <div class="r-form-group">
                <label class="title">{{ 'BUSINESS_COUPON.STATUS' | translate }}</label>
                <p-dropdown [options]="translatedStatusOptions" [(ngModel)]="selectedStatus" optionLabel="label"
                    optionValue="value" placeholder="{{ 'BUSINESS_COUPON.STATUS' | translate }}" [showClear]="true"
                    (onClear)="filterStatus()" (onChange)="filterStatus()">
                </p-dropdown>
            </div>
        </div>
</p-sidebar>
<div class="r-form-group totalRecords">
    {{ totalRecords }} {{ 'BUSINESS_COUPON.COUNT_BUSINESS_COUPONS' | translate }}
</div>
<div class="cards-container">
    <app-coupon-card-mobile *ngFor="let coupon of businessCoupons$ | async" [currentCoupon]="coupon"
        [columns]="columns" (resend)="resendWinningEmail($event)">
    </app-coupon-card-mobile>
</div>